import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expander-closed",
  "use": "expander-closed-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"expander-closed\">\n    <circle class=\"expander-circle\" cx=\"16\" cy=\"16\" r=\"15.5\" fill=\"none\" stroke=\"var(--action-color, var(--accent-blue-600))\" />\n    <path class=\"expander-inner\" d=\"M16.5 11v4.5H21v1h-4.5V21h-1v-4.5H11v-1h4.5V11h1z\" fill=\"var(--action-color, var(--accent-blue-600))\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol